<script setup lang="ts">
import type { FilterCategory, FilterDraft, FilterToggle } from '#shared/mobile-filter-drawer'
import { faBookmark, faBuildingColumns, faPenNib } from '@fortawesome/pro-light-svg-icons'

const openFilter = defineModel('openFilter', { default: false })

const { legalAreaOptions, authorOptions, selectedLegalArea, selectedAuthor, showOnlyFavorites, countWithFilters } = useTemplateFilters()
const { loggedIn } = useUserSession()

const categories = computed<FilterCategory[]>(() => [
  { id: 'rettsområde', label: 'Rettsområde', icon: faBuildingColumns, options: legalAreaOptions.value, resetAriaLabel: 'Nullstill rettsområde' },
  { id: 'forfatter', label: 'Forfattere', icon: faPenNib, options: authorOptions.value, resetAriaLabel: 'Nullstill forfatter' },
])

const toggles = computed<FilterToggle[]>(() =>
  loggedIn.value ? [{ id: 'favoritter', label: 'Favoritter', icon: faBookmark }] : [],
)

const initial = computed<FilterDraft>(() => ({
  categories: { rettsområde: selectedLegalArea.value, forfatter: selectedAuthor.value },
  toggles: { favoritter: showOnlyFavorites.value },
}))

function count(draft: FilterDraft) {
  return countWithFilters({
    selectedLegalArea: draft.categories.rettsområde ?? [],
    selectedAuthor: draft.categories.forfatter ?? [],
    showOnlyFavorites: draft.toggles.favoritter ?? false,
  })
}

function onCommit(draft: FilterDraft) {
  selectedLegalArea.value = [...(draft.categories.rettsområde ?? [])]
  selectedAuthor.value = [...(draft.categories.forfatter ?? [])]
  showOnlyFavorites.value = draft.toggles.favoritter ?? false
}
</script>

<template>
  <MobileFilterDrawer
    v-model:open="openFilter"
    :categories="categories"
    :toggles="toggles"
    :initial="initial"
    :count="count"
    @commit="onCommit"
  />
</template>